import { Charts } from 'types/Meteorology/Agro/CultureIndex/Location/getCharts';

// Legendas que a API já monta são dimensionadas para desktop e ficam grandes/
// sobrepostas no mobile. Aqui preservamos os dados/posição da legenda (inclusive
// legendas customizadas, ex. as faixas do Índice de Desenvolvimento) e só a
// deixamos compacta: fonte menor, itens menores, ancorada no topo.
const compactLegend = (legend: unknown) => {
  const overrides = {
    top: 4,
    type: 'scroll' as const,
    itemWidth: 12,
    itemHeight: 8,
    itemGap: 8,
  };
  const textOverride = { fontSize: 10 };

  if (Array.isArray(legend)) {
    return legend.map((item) => ({
      ...(item as object),
      ...overrides,
      textStyle: { ...((item as any)?.textStyle), ...textOverride },
    }));
  }

  return {
    ...(typeof legend === 'object' && legend !== null ? legend : {}),
    ...overrides,
    textStyle: { ...((legend as any)?.textStyle), ...textOverride },
  };
};

/**
 * Adapta um EChartsOption pronto da API para o card mobile: esconde o título
 * (vira o header do card), abre espaço no topo para a legenda, deixa a legenda
 * compacta e liga o zoom sincronizado controlado de fora.
 */
export default function buildMobileChartOption(
  option: Charts,
  zoomStart: number,
  zoomEnd: number,
  gridTop: number | string = 64,
) {
  return {
    ...option,
    title: {
      ...(typeof option.title === 'object' ? option.title : {}),
      show: false,
    },
    legend: compactLegend((option as any).legend),
    grid: {
      left: '5%',
      right: '6%',
      bottom: 24,
      top: gridTop,
      containLabel: true,
    },
    dataZoom: [{
      type: 'slider' as const,
      show: false,
      xAxisIndex: 0,
      filterMode: 'none' as const,
      start: zoomStart,
      end: zoomEnd,
    }],
    animation: false,
  };
}
